export const INSIGHT_DRAWER_SECTION_KEYS = [
  'audienceBreakdown',
  'contactability',
  'macroeconomicScorecard',
  'bigPlayers',
  'painPoints',
  'horizonScanning',
  'productMapping',
  'icpTiers'
] as const;

export type InsightDrawerSectionKey =
  (typeof INSIGHT_DRAWER_SECTION_KEYS)[number];

export const INSIGHT_DRAWER_SECTION_LABELS: Record<
  InsightDrawerSectionKey,
  string
> = {
  audienceBreakdown: 'Audience breakdown',
  contactability: 'Contactability',
  macroeconomicScorecard: 'Macroeconomic scorecard',
  bigPlayers: 'Big players — size vs income',
  painPoints: 'Pain points',
  horizonScanning: 'Horizon scanning',
  productMapping: 'Product mapping',
  icpTiers: 'ICP tiers'
};

export const INSIGHT_DRAWER_STAGGER_MS = 90;

export function insightDrawerSectionDelay(
  index: number,
  reduceMotion: boolean
) {
  return reduceMotion ? 0 : index * INSIGHT_DRAWER_STAGGER_MS;
}
